import { t } from '@lingui/core/macro';

import { useAttributionOpportunitiesTrend } from '@/api/attribution';
import { type OpportunityStatusOldType } from '@/api/opportunity';
import { usePageFilterContext } from '@/components/page';
import { Panel } from '@/components/panels';
import { OpportunityInfluenceChart } from '@/features/OpportunityInfluenceChartTableCombo';

type Props = {
  oppType: OpportunityStatusOldType;
};

const AttributionTrendsChart = ({ oppType }: Props) => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();
  const { attributionTrend, isLoading, error } = useAttributionOpportunitiesTrend(
    startDate,
    endDate,
    audience?.isTAM ? undefined : audience?.id,
  );

  return (
    <Panel
      title={t`Attribution Trend`}
      infoPopover={{
        title: t`Attribution Trend`,
        body: t`Weekly pipeline value of opportunities which have closed or were created depending on the Closed Won or Pipeline page-level filter.`,
      }}
      noPadding
    >
      <OpportunityInfluenceChart
        opportunityType={oppType}
        data={attributionTrend}
        isLoading={isLoading}
        error={error}
      />
    </Panel>
  );
};

export default AttributionTrendsChart;
